import Vue from 'vue'
import Router from 'vue-router'
import RemoteLog from '@/tools/remote-log'

Vue.use(Router)
import otherRouter from './otherRouters'
import ValueAddedServiceDetail from '../views/details/value-added-service'
import HardwareMarketDetail from '../views/details/hardware-market'
import RechargePhone from '../views/details/recharge/phone'
import RechargeMessage from '../views/details/recharge/message'
import Ticket from '../views/tickets'
import OrderConfirm from '../views/order/confirm'
import AboutMe from '../views/about-me'
import AboutMeOrderDetail from '../views/about-me/order-detail'
import AboutMeOrderItemDetail from '../views/about-me/order-detail/item-detail'
import AboutMeTicketDetail from '../views/about-me/ticket-detail'
import AboutMeIntegralDetail from '../views/about-me/integral-detail'
import PayStatus from '../views/pay-status'
import PayStatusFailed from '../views/pay-status/pay-failed'
import InnerWebView from '../views/inner-web-view'
import OrderRenewal from '../views/order/renewal'
import LaobanCoupon from '../views/tabs/2018-05-18/coupon/index.vue'
import LaobanShare from '../views/tabs/2018-05-18/share/index.vue'
import CardBind from '../views/coupon/card-bind'
import CardBindResult from '../views/coupon/card-bind/result'
import AppleProtocol from '../views/about-me/apple-auto-renew-protocol'
import UserProtocol from '../views/about-me/user-protocol'
import ServiceProtocol from '../views/about-me/service-protocol'
import Dealer from '../views/dealer'   // 成为代理商宣传
import Provision from '../views/provision'
import Renewal from '../views/renewal'  // 续费所用页面
import NewRenew from '../views/newrenew' // 新版续费

import Christmax from '../views/christmas' // 双蛋节活动h5

import StoreChristmax from '../views/store-christmax'
// 邀请有礼
import Invite from '../views/invite/index'

import NewEleven from '../views/2020-11-11/index'

const OrderAddress = resolve => require(['../views/order/address'], resolve)

const payComponent = function (root = '') {
  return {
    path: `${root}paystatus`,
    name: Symbol('PayStatus'),
    component: PayStatus,
    children: [
      {
        path: 'failed',
        component: PayStatusFailed,
        children: []
      }
    ]
  }
}

const router = new Router({
  routes: [
    {
      path: '/valueAddedService/detail/:id',
      name: 'vasDetail',
      component: ValueAddedServiceDetail,
      children: [
        payComponent()
      ]
    }, {
      path: '/hardwareMarket/detail/:id',
      name: 'hardwareDetail',
      component: HardwareMarketDetail,
      children: [
        {
          path: 'orderConfirm',
          name: 'orderConfirm',
          component: OrderConfirm,
          children: [
            {
              path: 'editOrderAddress',
              name: 'editOrderAddress',
              component: OrderAddress,
              children: []
            }, {
              path: 'selectGoodsTicket',
              name: 'selectGoodsTicket',
              component: Ticket,
              children: []
            }, payComponent()
          ]
        }
      ]
    },
    {
      path: '/recharge/phone',
      name: 'rechargePhoneDetail',
      component: RechargePhone,
      children: [
        payComponent()
      ]
    }, {
      path: '/recharge/message',
      name: 'rechargeMessageDetail',
      component: RechargeMessage,
      children: [
        payComponent()
      ]
    },
    {
      path: '/goodsTicket',
      name: 'goodsTicket',
      component: Ticket,
      children: []
    }, {
      path: '/aboutMe',
      name: 'aboutMe',
      component: AboutMe,
      children: [{
        path: 'orderDetail',
        name: 'AboutMeOrderDetail',
        component: AboutMeOrderDetail,
        children: [{
          path: 'itemDetail',
          name: 'AboutMeOrderItemDetail',
          component: AboutMeOrderItemDetail,
          children: [
            payComponent()
          ]
        }]
      }, {
        path: 'ticketDetail',
        name: 'AboutMeTicketDetail',
        component: AboutMeTicketDetail,
        children: []
      }, {
        path: 'integralDetail',
        name: 'AboutMeIntegralDetail',
        component: AboutMeIntegralDetail,
        children: []
      }]
    }, {
      path: '/innerwebview',
      component: InnerWebView
    }, {
      path: '/laobanCoupon',
      component: LaobanCoupon,
      children: []
    }, {
      path: '/activeShare',
      component: LaobanShare,
      children: []
    }, {
      path: '/orderConfirm',
      name: 'orderConfirm',
      component: OrderConfirm,
      children: [
        {
          path: 'editOrderAddress',
          name: 'editOrderAddress',
          component: OrderAddress,
          children: []
        }, {
          path: 'selectGoodsTicket',
          name: 'selectGoodsTicket',
          component: Ticket,
          children: []
        }, payComponent()
      ]
    }, {
      path: '/rechargeSaas/:id',
      component: OrderRenewal,
      children: [
        payComponent()
      ]
    }, {
      path: '/card-bind',
      component: CardBind,
      children: [{
        path: 'result',
        component: CardBindResult
      }]
    }, {
      path: '/apple-auto-renew-protocol',
      component: AppleProtocol
    }, {
      path: '/user-protocol',
      component: UserProtocol
    }, {
      path: '/service-protocol',
      component: ServiceProtocol
    }, {
      path: '/dealer',
      component: Dealer,
      children: []
    }, {
      path: '/invite',
      component: Invite
    }, {
      path: '/provision',
      component: Provision
    }, {
      path: '/christmax',
      component: Christmax
    }, {
      path: '/storechristmax',
      component: StoreChristmax
    }, {
      path: '/renewal/:payType',
      component: Renewal,
      children: [
        payComponent()
      ]
    }, {
      path: '/newrenew',
      component: NewRenew
    }, {
      path: '/newEleven',
      component: NewEleven
    },
    ...otherRouter,
    payComponent('/')
  ]
})

router.beforeEach((to, from, next) => {
  if (!('$cRouter' in Vue.prototype)) {
    Vue.prototype.$cRouter = {
      path: to.path
    }
  }
  RemoteLog.userVisitPath(to.fullPath)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js